import styled from '@emotion/styled';
import React from 'react'

const DashBoardCard = ({ title, totalUsers, percentage ,onClick}) => {
    return (
        <>
            <Container className={`card ${onClick && "pointer"}`} onClick={onClick}>
                <Header>
                    {title}
                </Header>
                <Body>
                    <strong>
                        {totalUsers}
                    </strong>
                    {(percentage || percentage === 0) && <small className={percentage >= 0 ? "green" : "red"}>{parseFloat(percentage).toFixed(1)}% <span>since last month</span></small>}
                </Body>
            </Container>
        </>
    )
}

const Container = styled("div")`
    min-width: 240px;
    border-radius: 8px;
    box-shadow: rgba(149, 157, 165, 0.3) 0px 8px 24px;
`;

const Header = styled("div")`
    display: flex;
    padding: 1rem;
    font-weight: 600;
    font-size: 80%;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    display: grid;
    padding: 0.7rem 1rem;
    padding-bottom: 1rem;
    small{
        font-size: 70%;
        span{
            margin-left: 0.3rem;
        }
    }
`;

export default DashBoardCard